<template>
  <header class="header">
    <nav class="navbar">
      <div class="logo">
        <router-link to="/">LBC Vue App</router-link>
      </div>
      <ul class="nav-links">
        <li v-if="!isAuthenticated">
          <router-link to="/login" class="nav-item">Login</router-link>
          <router-link to="/register" class="nav-item">Register</router-link>
        </li>
        <li v-else>
          <router-link to="/dashboard" class="nav-item">Dashboard</router-link>
          <router-link to="/profile" class="nav-item">Profile</router-link>
          <button @click="logout" class="logout-button">Logout</button>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import authService from '@/services/authService';

export default {
  name: "AppHeader",
  computed: {
    isAuthenticated() {
      return authService.isAuthenticated();
    },
  },
  methods: {
    logout() {
      authService.logout();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #336699;
  padding: 15px;
  color: #fff;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 1.5em;
  font-weight: bold;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 15px;
}

.nav-links li {
  margin-right: 15px;
}

.nav-item {
  margin-right: 15px;
}

.logout-button {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
}

a {
  color: #fff;
  text-decoration: none;
}
</style>